{
  "greeting": {
    "salam": "السلام علیکم",
    "salamWithName": "السلام علیکم، {{name}}"
  },
  "dock": {
    "saved": "ذخیره‌شده",
    "savedVerses": "آیه‌های ذخیره‌شده",
    "tasks": "وظایف",
    "notes": "یادداشت‌ها"
  },
  "actions": {
    "save": "ذخیره",
    "cancel": "لغو",
    "close": "بستن",
    "delete": "حذف",
    "rename": "تغییر نام",
    "dismiss": "نادیده گرفتن",
    "loading": "در حال بارگذاری…",
    "reload": "بارگذاری مجدد",
    "retry": "تلاش دوباره",
    "expand": "گسترش",
    "collapse": "جمع کردن"
  },
  "nav": {
    "appNavigation_aria": "ناوبری برنامه"
  },
  "tabs": {
    "home": "خانه",
    "tasks": "کارها",
    "notes": "یادداشت‌ها",
    "more": "بیشتر"
  },
  "more": {
    "daily": "روزانه",
    "account": "حساب",
    "savedVerses": "آیات ذخیره‌شده",
    "qibla": "قبله",
    "prayerTimes": "اوقات نماز و یادآورها",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "از طریق حساب Rhemn شما مدیریت می‌شود",
    "upgrade": "ارتقا",
    "privacyPolicy": "سیاست حریم خصوصی",
    "version": "Rhemn · v{{version}}",
    "back_aria": "بازگشت",
    "deleteAccount": "حذف حساب"
  },
  "reflection": {
    "dismiss_aria": "بستن تأمل"
  },
  "app": {
    "loading_aria": "ریمن در حال بارگذاری است",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "اشتراک ریمن پرو خود را در وب مدیریت کنید. وقتی با حساب دارای اشتراک خود وارد شوید، پرو به‌طور خودکار اینجا فعال می‌شود."
  },
  "header": {
    "qiblaDirection_aria": "جهت قبله",
    "prayerTimes_aria": "اوقات نماز",
    "prayerTimesTitle": "اوقات نماز",
    "method": "روش",
    "methodHelp": "روش بر اوقات محاسبه‌شده اثر می‌گذارد"
  },
  "search": {
    "search_aria": "جستجو",
    "searchLabel": "جستجو",
    "searchWeb_placeholder": "جستجو در وب"
  },
  "focus": {
    "input_placeholder": "امروز چه چیزی بیشترین اهمیت را دارد؟",
    "example_worship": "نماز با حضور قلب، نه با عجله",
    "example_kindness": "به مادرم زنگ بزنم فقط برای شنیدنش",
    "example_reflect": "بر نیت خود با آیه امروز تأمل کن",
    "saveIntention_aria": "ذخیره نیت",
    "celebration": "🤲 ماشاءالله"
  },
  "profile": {
    "profileFallback": "نمایه",
    "profileAndAccount_aria": "نمایه و حساب",
    "profileDialog_aria": "نمایه",
    "editName_aria": "ویرایش نام شما",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "مدیریت اشتراک",
    "manageSubscription_aria": "مدیریت اشتراک ریمن پرو شما",
    "anonymousAnalytics": "تحلیل ناشناس",
    "anonymousAnalyticsNote": "فقط تجمیعی — هرگز به شما پیوند نمی‌خورد",
    "shareAnalytics_aria": "اشتراک‌گذاری تحلیل استفاده ناشناس",
    "signOut": "خروج",
    "signingOut": "در حال خروج…",
    "signOut_aria": "خروج از ریمن",
    "restorePurchases": "Restore purchases",
    "restorePurchases_aria": "Restore previous purchases"
  },
  "background": {
    "loading": "در حال بارگذاری پس‌زمینه...",
    "fallbackNotice": "استفاده از تصویر جایگزین (Unsplash API در دسترس نیست)",
    "noImage": "تصویر پس‌زمینه‌ای موجود نیست",
    "error": "خطا: {{message}}",
    "photoByOnUnsplash": "عکس از <photographer>{{name}}</photographer> در <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "مشکلی پیش آمد",
    "fallbackMessage": "خطایی غیرمنتظره رخ داد."
  },
  "theme": {
    "switchToLight_title": "تغییر به حالت روشن",
    "switchToDark_title": "تغییر به حالت تیره"
  },
  "upgradeCta": {
    "upgradeToPro": "ارتقا به پرو",
    "restorePurchases": "Restore purchases",
    "restoring": "Restoring…",
    "restoreEmpty": "No purchases found.",
    "pricePerMonth": "{{price}} / ماه",
    "pricePerYear": "{{price}} / سال",
    "purchasePending": "در انتظار تأیید. به محض تأیید خرید، Pro به‌طور خودکار فعال می‌شود.",
    "storeUnavailable": "در حال حاضر دسترسی به App Store ممکن نیست. کمی بعد دوباره تلاش کنید.",
    "purchaseFailed": "خرید کامل نشد. کمی بعد دوباره تلاش کنید."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · ۲۵٪ تخفیف برای سال اول",
    "title": "برای ساعت‌های میان نمازهایتان.",
    "body": "یادداشت‌های صوتی که پیاده، خلاصه و به کار تبدیل می‌شوند. برنامه‌ریز روزانه‌ای که بر پایهٔ اوقات نماز شما ساخته شده. یادداشت‌ها با هوش مصنوعی.",
    "price": "$29.99",
    "period": "برای سال اول",
    "priceIos": "۲۵٪ تخفیف برای سال اول",
    "terms": "پس از آن سالانه $39.99. کد {{code}} برایتان اعمال شده است.",
    "termsIos": "با قیمت عادی سالانه تمدید می‌شود. از کد {{code}} در App Store استفاده کنید.",
    "free": "اوقات نماز، قبله، آیهٔ روز و کارها رایگان می‌مانند.",
    "cta": "ارتقا به پرو",
    "dismiss": "الان نه"
  },
  "planChooser": {
    "monthly": "ماهانه",
    "yearly": "سالانه",
    "yearlyValue": "چهار ماه مهمان ما.",
    "freeNote": "اوقات نماز، قبله، آیهٔ روز و کارها رایگان است. Rhemn Pro این‌ها را اضافه می‌کند:",
    "includes_planner": "برنامهٔ روز حول پنج نماز، به‌همراه «برنامه‌ریزی روز من»",
    "includes_insights": "بینش‌های قرآن — دربارهٔ هر آیه بپرسید و زمینهٔ آن را بخوانید",
    "includes_reflections": "تأملات آیهٔ روز، متناسب با نیتی که ثبت کرده‌اید",
    "includes_notes": "یادداشت‌ها و یادداشت‌های صوتی، با خلاصه‌سازی و ویرایش هوش مصنوعی",
    "includes_extras": "آیه‌های ذخیره‌شده، کارت آیه، زنجیرهٔ روزها و پیش‌بینی ۵ روزه",
    "renewsMonthly": "تا زمان لغو، هر ماه تمدید می‌شود",
    "renewsYearly": "تا زمان لغو، هر ۱۲ ماه تمدید می‌شود",
    "continue": "ادامه",
    "renewalTerms": "هزینه هنگام تأیید خرید از Apple ID شما کسر می‌شود. اشتراک به‌طور خودکار تمدید می‌شود مگر آنکه حداقل ۲۴ ساعت پیش از پایان دوره، تمدید خودکار خاموش شود. هر زمان از تنظیمات Apple ID مدیریت یا لغو کنید.",
    "retry": "تلاش دوباره"
  },
  "streak": {
    "badge_aria": "استمرار روزانه — {{count}} روز",
    "title": "استمرار روزانه",
    "daysWithCount": "استمرار {{count}} روزه",
    "start": "از امروز آغاز کنید — لحظه‌ای با آیه بگذرانید یا نمازی را ثبت کنید.",
    "prayedToday": "امروز نماز خواندم",
    "readVerse": "آیه امروز را خواندم",
    "autoHint": "وقتی لحظه‌ای با آیه بگذرانید، خودش ثبت می‌شود.",
    "milestoneTitle": "{{count}} روز نیت",
    "milestoneBody": "الحمد لله. این دستاورد را به اشتراک بگذارید — شاید عزیزی از شما هم آغاز کند.",
    "share": "اشتراک‌گذاری",
    "dismiss": "حالا نه",
    "cardLabel": "روز نیت",
    "shareCaption": "{{count}} روز آغاز با نیت — rhemn.com",
    "imageSaved": "تصویر ذخیره شد.",
    "couldNotCreateImage": "تصویر ساخته نشد. لطفاً دوباره تلاش کنید."
  },
  "qibla": {
    "compassIcon_aria": "نماد قطب‌نما",
    "title": "جهت قبله",
    "locationUnavailable": "موقعیت مکانی در دسترس نیست",
    "locating": "در حال یافتن موقعیت…",
    "compass_aria": "قطب‌نمای قبله",
    "directionN": "ش",
    "directionE": "خ",
    "directionS": "ج",
    "directionW": "غ",
    "facingQibla": "رو به قبله",
    "enableLiveCompass": "فعال‌سازی قطب‌نمای زنده",
    "enableLiveCompassNote": "از حسگر حرکت استفاده می‌کند تا با چرخش شما، فلش حرکت کند — نه موقعیت مکانی",
    "directionToMecca": "جهت به سوی مکه",
    "enableLocation": "برای محاسبه جهت، دسترسی به موقعیت مکانی را فعال کنید",
    "hintLive": "فلش، جهت‌گیری دستگاه شما را در لحظه دنبال می‌کند",
    "hintStatic": "زاویه نسبت به شمال — برای جهت دقیق همراه با قطب‌نما استفاده کنید",
    "live": "زنده",
    "footerVerse": "«پس روی خود را به سوی مسجدالحرام بگردان» – قرآن ۲:۱۴۴"
  },
  "legal": {
    "links_aria": "حقوقی",
    "termsOfUse": "شرایط استفاده",
    "privacyPolicy": "سیاست حریم خصوصی"
  },
  "auth": {
    "signInForPro": "ابتدا وارد شوید — Pro شما همه‌جا همراهتان است."
  },
  "integrations": {
    "row": {
      "label": "تقویم‌ها و کارها",
      "caption": "متصل",
      "subNone": "متصل نیست",
      "subFree": "تقویم گوگل، Google Tasks و بیشتر",
      "subAttention": "{{provider}} به توجه نیاز دارد",
      "subPaused": "همگام‌سازی متوقف شده"
    },
    "list": {
      "title": "تقویم‌ها و کارها",
      "subtitle": "جلسات و کارهایت را به روز خود بیاور.",
      "footnote": "ریمن فقط چیزی را می‌خواند که لازم دارد، و رویدادهای تو را هرگز ذخیره نمی‌کند.",
      "privacy": "سیاست حریم خصوصی",
      "connect": "اتصال",
      "connect_aria": "اتصال {{what}}",
      "checking": "در حال بررسی…",
      "loadError": "اتصال‌هایت بارگذاری نشد.",
      "tryAgain": "تلاش دوباره",
      "offline": "آفلاین هستی. وقتی برگشتی آنلاین، وصل کن.",
      "unavailable": "تقویم‌ها و کارها اکنون در دسترس نیست.",
      "disconnected": "اتصال {{provider}} قطع شد.",
      "google": {
        "name": "Google",
        "sub": "تقویم و کارها",
        "what": "تقویم و کارهای گوگل"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "کارها و پروژه‌ها",
        "what": "Todoist"
      },
      "apple": {
        "name": "تقویم و یادآورها",
        "subNative": "روی این {{device}}",
        "subSafari": "در برنامهٔ ریمن برای iPhone و Mac"
      },
      "synced": "همگام‌سازی‌شده {{when}}",
      "connectedSub": "متصل",
      "syncing": "در حال همگام‌سازی…",
      "reconnectSub": "برای ادامهٔ همگام‌سازی دوباره وصل شو",
      "errorSub": "آخرین همگام‌سازی تمام نشد",
      "pausedSub": "متوقف‌شده · Rhemn Pro پایان یافت"
    },
    "explainer": {
      "google": {
        "title": "اتصال تقویم و کارهای گوگل",
        "p1Lead": "تقویمت، فقط خواندنی",
        "p1Body": "ریمن رویدادهایت را در روزت نشان می‌دهد و می‌داند کی مشغولی. آن‌ها را ذخیره نمی‌کند.",
        "p2Lead": "کارهای گوگل، در هر دو جهت",
        "p2Body": "فهرست‌هایی که انتخاب می‌کنی همگام می‌مانند، تا هرجا باشی بتوانی کارها را تیک بزنی.",
        "p3Lead": "قابل لغو در هر زمان",
        "p3Body": "هر وقت خواستی قطع کن، از همین‌جا یا از حساب گوگلت.",
        "footnote": "گوگل دقیقاً نشان می‌دهد ریمن چه چیزی درخواست می‌کند."
      },
      "todoist": {
        "title": "اتصال Todoist",
        "p1Lead": "پروژه‌هایت، در هر دو جهت",
        "p1Body": "پروژه‌هایی که انتخاب می‌کنی همگام می‌مانند، تا هرجا باشی بتوانی کارها را تیک بزنی.",
        "p2Lead": "چگونه نگاشت می‌شود",
        "p2Body": "اولویت‌های Todoist به بحرانی، بالا، متوسط و پایین تبدیل می‌شوند. زیرکارهای عمیق‌تر از یک سطح به‌صورت گام‌های زیر کار اصلی‌شان نمایش داده می‌شوند.",
        "p3Lead": "قابل لغو در هر زمان",
        "p3Body": "هر وقت خواستی قطع کن، از همین‌جا یا از تنظیمات Todoist.",
        "cta": "ادامه به Todoist",
        "footnote": "Todoist از تو تأیید می‌خواهد."
      },
      "skip": "حالا نه",
      "cancel": "لغو",
      "waiting": "در انتظار {{provider}}…",
      "safariWaiting": "در تب جدید کارت را تمام کن، سپس به اینجا برگرد.",
      "safariReopen": "تب را دوباره باز کن",
      "denied": "{{provider}} دسترسی نداد، پس چیزی وصل نشد.",
      "error": "اتصال به {{provider}} برقرار نشد. کمی بعد دوباره تلاش کن."
    },
    "detail": {
      "back_aria": "بازگشت به تقویم‌ها و کارها",
      "syncNow": "همگام‌سازی الان",
      "intro": "انتخاب کن ریمن چه چیزی را همگام کند. هر وقت می‌توانی این را تغییر دهی.",
      "taskLists": "فهرست‌های کارها",
      "projects": "پروژه‌ها",
      "reminders": "یادآورها",
      "calendars": "تقویم‌ها",
      "rhemnCalendarSub": "اوقات نمازت، مشغول شمرده نمی‌شود",
      "loading": "در حال بارگذاری…",
      "loadError": "فهرست‌هایت بارگذاری نشد.",
      "emptyGoogle": "در Google Tasks فهرست کاری نیست.",
      "emptyTodoist": "در Todoist پروژه‌ای نیست.",
      "addError": "{{name}} اضافه نشد. دوباره تلاش کن.",
      "removed": "از ریمن حذف شد. هنوز در {{provider}} هست.",
      "undo": "بازگردانی",
      "prayerTimes": "افزودن اوقات نماز به تقویمت",
      "prayerTimesSub": "پنج نماز را برای ۷ روز آینده به تقویمی به نام Rhemn اضافه می‌کند، تا کسی روی آن‌ها برنامه نگذارد.",
      "prayerTimesOn": "روشن. تا {{date}} اضافه شد.",
      "prayerTimesWaiting": "در انتظار Google…",
      "prayerTimesDenied": "گوگل اجازه نداد. چیزی اضافه نشد.",
      "prayerTimesRemoveAsk": "اوقات نماز ریمن از تقویمت حذف شود؟",
      "prayerTimesKeep": "نگه‌داشتن",
      "prayerTimesRemove": "حذف",
      "meetingPrompts": "یادآوری جلسات",
      "meetingPromptsSub": "وقتی جلسه‌ای با لینک نزدیک شروع شدن است، پیشنهاد یادداشت‌برداری بده.",
      "busyFootnote": "برنامه‌ریزی روز من فقط زمان مشغول‌بودنت را می‌بیند، هرگز محتوای جلساتت را نه.",
      "todoistFootnote": "اولویت‌های Todoist به بحرانی، بالا، متوسط و پایین تبدیل می‌شوند. زیرکارهای عمیق‌تر از یک سطح به‌صورت گام‌های زیر کار اصلی‌شان نمایش داده می‌شوند.",
      "reauth": "{{provider}} دیگر اجازه همگام‌سازی به ریمن نمی‌دهد. این زمانی رخ می‌دهد که دسترسی حذف شود یا رمز عبورت تغییر کند.",
      "reconnect": "اتصال دوباره",
      "paused": "همگام‌سازی به‌دلیل پایان Rhemn Pro متوقف شده. فهرست‌هایت همان‌طور که بودند می‌مانند.",
      "calendarDenied": "دسترسی به تقویم خاموش است.",
      "remindersDenied": "دسترسی به یادآورها خاموش است.",
      "disconnect": "قطع اتصال {{provider}}",
      "disconnectTitle": "اتصال {{provider}} قطع شود؟",
      "disconnectBody": "چیزی در {{provider}} حذف نمی‌شود.",
      "disconnectRhemnCal": "تقویم اوقات نماز ریمن از Google Calendar حذف خواهد شد.",
      "disconnectError": "اتصال {{provider}} قطع نشد. کمی بعد دوباره تلاش کن.",
      "keepLists": "فهرست‌هایم را در ریمن نگه‌دار",
      "keepListsSub": "همگام‌سازی آن‌ها متوقف می‌شود و به فهرست‌های عادی ریمن تبدیل می‌شوند.",
      "removeLists": "آن‌ها را از ریمن حذف کن",
      "removeListsSub": "فقط نسخه‌های داخل ریمن حذف می‌شوند.",
      "disconnecting": "در حال قطع اتصال…",
      "appleStop": "توقف استفاده از تقویم و یادآورها",
      "appleStopTitle": "استفاده از تقویم و یادآورها متوقف شود؟",
      "appleStopBody": "ریمن نمایش رویدادها و یادآورهایت را متوقف می‌کند. برای حذف کامل دسترسی، آن را در تنظیمات خاموش کن.",
      "justNow": "همین الان",
      "tasksScope": "ریمن برای دیدن Google Tasks تو اجازه لازم دارد. دوباره وصل شو و برای اجازه دادن، Tasks را علامت بزن.",
      "calendarsLoadError": "تقویم‌هایت بارگیری نشد.",
      "calendarsEmpty": "در این حساب تقویمی نیست.",
      "calendarsScope": "ریمن برای دیدن تقویم گوگلت به اجازه نیاز دارد. دوباره وصل شو و برای اجازه، تقویم را علامت بزن.",
      "prayerTimesError": "اوقات نمازت اضافه نشد. کمی بعد دوباره امتحان کن.",
      "remindersEmpty": "در یادآورها فهرستی نیست.",
      "openSettings": "باز کردن تنظیمات",
      "appleStopCta": "توقف استفاده"
    },
    "locked": {
      "body": "جلساتت را درون بلوک‌های نمازت ببین، و Google Tasks را با ریمن همگام نگه‌دار.",
      "googleName": "تقویم و کارهای گوگل"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "دستگاه"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}، همگام‌شده با {{provider}}",
      "unlinkConfirm": "«{{name}}» از ریمن حذف شود؟ در {{provider}} باقی می‌ماند.",
      "remove": "حذف",
      "offline": "آفلاین · وقتی برگردی آنلاین، تغییرات با {{provider}} همگام می‌شود.",
      "stillSyncing": "همگام‌سازی با {{provider}} هنوز ادامه دارد…",
      "failed_one": "{{count}} تغییر به {{provider}} نرسید.",
      "failed_other": "{{count}} تغییر به {{provider}} نرسید.",
      "retry": "تلاش دوباره",
      "needsReconnect": "{{provider}} از تو می‌خواهد دوباره وصل شوی.",
      "paused": "همگام‌سازی متوقف شده · Rhemn Pro پایان یافت.",
      "upgrade": "ارتقا",
      "notSynced": "همگام نشده",
      "notSynced_aria": "با {{provider}} همگام نشده. دوباره تلاش کن.",
      "remindersOff": "ریمن به یادآورها دسترسی ندارد. آن را دوباره در تنظیمات روشن کن.",
      "dueToday": "امروز",
      "dueTomorrow": "فردا",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "تمام روز",
      "more": "+{{count}}",
      "more_aria": "نمایش {{count}} رویداد تمام‌روز دیگر",
      "less_aria": "نمایش رویدادهای تمام‌روز کمتر",
      "events_aria": "رویدادها",
      "event_aria": "{{start}} تا {{end}}، {{title}}",
      "allDayEvent_aria": "تمام روز، {{title}}",
      "untitled": "مشغول",
      "now": "اکنون · تا {{end}}",
      "until": "تا {{end}}",
      "into": "· تا {{prayer}}",
      "loadError": "تقویمت بارگیری نشد.",
      "needsReconnect": "تقویم گوگل از تو می‌خواهد دوباره وصل شوی.",
      "scope": "ریمن نمی‌تواند تقویم گوگلت را ببیند. دوباره وصل شو و برای اجازه، تقویم را علامت بزن.",
      "appleOff": "ریمن نمی‌تواند تقویمت را ببیند. آن را در تنظیمات دوباره روشن کن."
    },
    "plan": {
      "mostlyMeetings": "بیشتر جلسه · {{duration}} آزاد",
      "noFreeTime": "وقت آزادی نیست",
      "aroundMeetings_one": "برنامه با در نظر گرفتن {{count}} جلسه چیده شد.",
      "aroundMeetings_other": "برنامه با در نظر گرفتن {{count}} جلسه چیده شد.",
      "settledBusy": "همه‌چیز از قبل با جلسه‌هایت جور است."
    },
    "meeting": {
      "group_aria": "جلسه در حال شروع",
      "now": "اکنون",
      "takeNotes": "یادداشت‌برداری",
      "takeNotes_aria": "یادداشت‌برداری برای {{title}}",
      "dismiss_aria": "بستن",
      "announce": "{{title}} {{when}} شروع می‌شود.",
      "announceNow": "{{title}} همین حالا شروع می‌شود.",
      "yourMeeting": "جلسه‌ات"
    },
    "apple": {
      "primer": {
        "title": "تقویمت را کنار نمازهایت ببین",
        "body": "ریمن رویدادها و یادآورهای این {{device}} را می‌خواند تا آن‌ها را در روزت جای دهد. روی دستگاهت می‌مانند. «برنامه‌ریزی روزم» فقط از زمان‌هایی که مشغولی استفاده می‌کند.",
        "cta": "ادامه",
        "skip": "حالا نه",
        "footnote": "{{device}} دو بار می‌پرسد، یک بار برای تقویم و یک بار برای یادآورها. هر کدام را می‌توانی در تنظیمات تغییر دهی."
      }
    }
  }
}
